<form [formGroup]="form.formGroup">
  <div class="flex gap-2 flex-row m-2">
    <p-fieldset legend="Lower Stage (Bottom Plug)" class="w-1/2">
      <div class="grid gap-1">
        <app-uom-input
          label="Surface Pressure"
          [unitLabel]="pressureLabel"
          [formControlName]="form.formControlNames.lowerStageSurfacePressure"
          [control]="'lowerStageSurfacePressure'"
          [default]="'0'"
          [min]="pressureValidation.min"
          [max]="pressureValidation.max"
          title="Allowed range: {{ pressureValidation.min }} - {{ pressureValidation.max }} {{ pressureLabel }}"
        />

        <app-uom-input
          label="Fluid Density"
          [unitLabel]="densityLabel"
          [formControlName]="form.formControlNames.lowerStageFluidDensity"
          [control]="'lowerStageFluidDensity'"
          [default]="currentString.annularFluid.state?.nominalDensity"
          [min]="densityValidation.min"
          [max]="densityValidation.max"
          title="Allowed range: {{ densityValidation.min }} - {{ densityValidation.max }} {{ densityLabel }}"
        />

        <div>
          <p-checkbox
            size="small"
            binary="true"
            [formControlName]="form.formControlNames.lowerStageHasPlug"
            (change)="lowerStagePlugChange()"
            inputId="lowerStageHasPlug"
          />
          <label class="ml-2" for="lowerStageHasPlug">Has Plug</label>
        </div>

        <app-uom-input
          label="Plug Depth"
          [unitLabel]="userUnits.longLengths + ' MD'"
          [formControlName]="form.formControlNames.lowerStagePlugMd"
          [control]="'lowerStagePlugMd'"
          [default]="null"
          [min]="currentString.hangerMd + 1"
          [max]="currentString.shoeMd"
          [inputDisabled]="lowerStagePlugDepthDisabled"
          (focusout)="setPlugDepth()"
        />
      </div>
    </p-fieldset>

    <p-fieldset legend="Upper Stage (Top Plug)" class="w-1/2">
      <div class="grid gap-1">
        <div>
          <p-checkbox
            binary="true"
            [formControlName]="form.formControlNames.upperStageEvacAbovePlug"
            (change)="upperStagePlugChange()"
            inputId="upperStageEvacAbovePlug"
          />
          <label for="upperStageEvacAbovePlug" class="ml-2">Evacuated above plug</label>
        </div>

        <app-uom-input
          label="Surface Pressure"
          [unitLabel]="userUnits.pressure"
          [formControlName]="form.formControlNames.upperStageSurfacePressure"
          [control]="'upperStageSurfacePressure'"
          [default]="'0'"
          [min]="pressureValidation.min"
          [max]="pressureValidation.max"
          [inputDisabled]="upperStageEvacAbovePlug"
          title="Allowed range: {{ pressureValidation.min }} - {{ pressureValidation.max }} {{ pressureLabel }}"
        />

        <app-uom-input
          label="Fluid Density"
          [unitLabel]="densityLabel"
          [formControlName]="form.formControlNames.upperStageFluidDensity"
          [control]="'upperStageFluidDensity'"
          [default]="currentString.annularFluid.state?.nominalDensity"
          [min]="densityValidation.min"
          [max]="densityValidation.max"
          [inputDisabled]="upperStageEvacAbovePlug"
          title="Allowed range: {{ densityValidation.min }} - {{ densityValidation.max }} {{ densityLabel }}"
        />

        <app-uom-input
          label="Plug/Valve Depth"
          [unitLabel]="userUnits.longLengths + ' MD'"
          [formControlName]="form.formControlNames.upperStagePlugMd"
          [control]="'upperStagePlugMd'"
          [default]="currentString.hangerMd + 100"
          [min]="currentString.hangerMd + 1"
          [max]="currentString.shoeMd"
        />
      </div>
    </p-fieldset>
  </div>

</form>
